export default "__VITE_ASSET__CZTXS0cm__"